
import $ from 'jquery';
import { register } from './../exports/theme-sections';
import { swatchSection } from './../exports/swatches';
import slickSlider from './../features/slick-slider';

const selectors = {
  collectionToggle: '[data-collection-toggle]',
  collectionRow: '[data-collection-row]'
};

class CollectionToggle {
  constructor(el) {
    this.container = el;
    let $container = $(this.container);

    $container.find(selectors.collectionToggle).click(function(evt){
      let collection = $(this).attr('data-collection-toggle');

      // Update button state
      $container.find('.collection-toggle__item').removeClass('active');
      $(this).closest('.collection-toggle__item').addClass('active');

      $container
        .find(selectors.collectionRow)
        .removeClass('in')
        .filter(`[data-collection-row="${collection}"]`)
        .addClass('in')
        .find('.slick-slider')
        .slick('refresh');
    })
  }
}

const collectionToggle = {
  onLoad() {
    new CollectionToggle(this.container);
  },
};
register('collection-rows', [swatchSection, slickSlider, collectionToggle]);
